export default "__VITE_ASSET__DFm321lm__"